if (document.getElementsByClassName('js-inCount')[0]) {
  module()
}
function module() {
  //   ####   #####   ##   ##  ##     ##  ######
  //  ##     ##   ##  ##   ##  ####   ##    ##
  //  ##     ##   ##  ##   ##  ##  ## ##    ##
  //  ##     ##   ##  ##   ##  ##    ###    ##
  //   ####   #####    #####   ##     ##    ##
  /*
  画面に入った数字データのカウントアップまたはカウントダウン

  data-count-start 初期値
  data-count-end 最終値　小数や負の値にも対応
  data-count-step 1ループ毎の増加値　省略で自動計算

<span class="js-inCount" data-count-start="0" data-count-end="50" data-count-step="">0</span>
<br>
<span class="js-inCount" data-count-start="0" data-count-end="100" data-count-step="">0</span>
<br>
<span class="js-inCount" data-count-start="0" data-count-end="1500.05" data-count-step="">0</span>
<br>
<span class="js-inCount" data-count-start="0" data-count-end="-15450.995" data-count-step="">0</span>
<br>
<span class="js-inCount" data-count-start="0" data-count-end="500" data-count-step="1">0</span>
  */
  //

  //            ##  ##     ##
  //            ##  ####   ##
  //  ########  ##  ##  ## ##
  //            ##  ##    ###
  //            ##  ##     ##
  // 画面に入った監視対象をカウントアップ
  // Intersection Observer
  window.intObsCount = function () {
    const intObsOption = {
      rootMargin: '-20px 0px',
      threshold: 0,
    };
    const observer = new IntersectionObserver(intObsCallback, intObsOption);
    const intObsItems = document.querySelectorAll('.js-inCount:not(.counted)');

    intObsItems.forEach((intObsItem) => {
      observer.observe(intObsItem);
    });

    function intObsCallback(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const entryItem = entry.target;
          entryItem.classList.add('counted');

          let countStart = parseFloat(entryItem.dataset.countStart) || 0;
          let countEnd = parseFloat(entryItem.dataset.countEnd.replace(/,/g, '')) || 0;
          let countStep = parseFloat(entryItem.dataset.countStep);

          if (!countStep) {
            countStep = (countEnd - countStart) * 0.03;
            countStep = Math.max(countStep, countEnd >= 1 ? 1 : 0.1); // 最低でも1 or 0.1
          }

          const decimalLength = getDecimalLength(countEnd);
          countStep = parseFloat(countStep.toFixed(decimalLength));

          valCountUp(entryItem, countStart, countEnd, countStep);
          observer.unobserve(entryItem);
        }
      });
    }

    function valCountUp(element, start, end, step) {
      let count = start;
      const interval = setInterval(() => {
        count += step;
        if (count >= end) {
          count = end;
          clearInterval(interval);
        }
        element.innerText = count >= 1000 ? count.toLocaleString() : count; // 1000以上ならカンマ追加
      }, 30); // アニメーションのスピード調整
    }

    function getDecimalLength(num) {
      if (Number.isInteger(num)) return 0;
      const str = num.toString().split('.')[1];
      return str ? str.length : 0;
    }
  };

  window.intObsCount();




  //             ####   #####   ##   ##  ##     ##  ######
  //            ##     ##   ##  ##   ##  ####   ##    ##
  //  ########  ##     ##   ##  ##   ##  ##  ## ##    ##
  //            ##     ##   ##  ##   ##  ##    ###    ##
  //             ####   #####    #####   ##     ##    ##
  // 再帰的なカウント描画
  function valCountUp(item, countStart, countEnd, countStep = 1) {
    if (countStart !== countEnd) {
      // 途中表示の補正処理
      const decimalLength = getDecimalLength(countEnd) // 小数の桁数
      countStart = countStart.toFixed(decimalLength) // ステップの小数桁数を最終値に揃える
    }

    const countSplit = String(countStart).split('.') // 小数点を基準に分割

    // 値を反映
    item.innerHTML = '<span class="">' + countSplit[0] + '</span>'
    if (countSplit[1]) {
      // 小数がある場合表示を追加
      item.innerHTML = item.innerHTML + '</span><span class="">.</span>' + '<span class="">' + countSplit[1] + '</span>'
    }

    countStart = parseFloat(countStart) // 表示用補正で文字列になっているのでfloatに直す

    if (countStart === countEnd) {
      // 同値なら終了
      return
    }

    countStart += countStep // カウントを進める

    // 判定用の絶対値を求める
    const countStartAbs = Math.abs(countStart)
    const countEndAbs = Math.abs(countEnd)

    if (countStartAbs > countEndAbs) {
      // オーバーしたら最大値に揃える
      countStart = countEnd
    }

    // 再帰呼び出し
    let timerVal = 60 // カウントミリ秒に変更
    const progress = countStartAbs / countEndAbs // 進捗を求める

    // 進捗に応じて加減速を調整
    if (progress <= 0.3) {
      timerVal = 60 * 0.1 // 最初は少し遅く
    } else if (progress <= 0.6) {
      timerVal = 60 * 0.3 // 中程度
    } else if (progress <= 0.7) {
      timerVal = 60 * 0.5 // 加速
    } else if (progress <= 0.8) {
      timerVal = 60 * 0.7 // 加速
    } else if (progress <= 0.9) {
      timerVal = 60 * 0.9 // 速く
    } else if (progress <= 1) {
      timerVal = 60 // 最後は1200msに調整
    }

    setTimeout(function () {
      valCountUp(item, countStart, countEnd, countStep)
    }, timerVal)
  }

  //            #####  ##   ##  ##     ##   ####
  //            ##     ##   ##  ####   ##  ##
  //  ########  #####  ##   ##  ##  ## ##  ##
  //            ##     ##   ##  ##    ###  ##
  //            ##      #####   ##     ##   ####
  // 小数の桁数を取得する
  function getDecimalLength(number) {
    const numbers = String(number).split('.')

    return numbers[1] ? numbers[1].length : 0
  }
}
